var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRulerVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 464V48C256 21.6 234.4 0 208 0H48C21.6 0 0 21.6 0 48V464C0 490.4 21.6 512 48 512H208C234.4 512 256 490.4 256 464ZM48 464V48H208V96H160C151.2 96 144 103.2 144 112V112C144 120.8 151.2 128 160 128H208V192H160C151.2 192 144 199.2 144 208V208C144 216.8 151.2 224 160 224H208V288H160C151.2 288 144 295.2 144 304V304C144 312.8 151.2 320 160 320H208V384H160C151.2 384 144 391.2 144 400V400C144 408.8 151.2 416 160 416H208V464H48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerVertical);
export default __webpack_public_path__ + "static/media/ruler-vertical.6ba86b6bd044aa0c69581bd931ae9c53.svg";
export { ForwardRef as ReactComponent };